<ul class="mobile-links mobile-links--level--{{ level }}" appCollapse>
    <li *ngFor="let link of menuItems">
        <div class="mobile-links__item" appCollapseItem="mobile-links__item--open" #item="appCollapseItem">
            <div class="mobile-links__item-title" [ngClass]="{'active':link.pageURL === currentUrl}"
                (click)="menuAction(link)">
                <!-- <img src="../../assets/images/svg/{{link.iconName}}" class="menu-icon mt-2"> -->
                <i class="{{ link.iconClass }} menu-icon" aria-hidden="true"></i>
                <a class="mobile-links__item-link" (click)="onItemClick(link)"
                    [routerLink]="link?.pageURL ? link?.pageURL : null">{{ link?.pageCaption }}</a>
                <button *ngIf="link?.subMenu?.length" class="mobile-links__item-toggle" type="button"
                    (click)="item.toggle()">
                    <app-icon class="mobile-links__item-arrow" name="arrow-rounded-down-12x7" size="12x7"></app-icon>
                </button>
            </div>
            <div *ngIf="link.subMenu?.length" class="mobile-links__item-sub-links" appCollapseContent>
                <ul class="mobile-links mobile-links--level--{{ level }}" appCollapse *ngIf="link.subMenu?.length">
                    <li class="nav-item sub" *ngFor="let submenu of link.subMenu"
                        [ngClass]="{'subactive':submenu.pageURL === currentUrl}" (click)="menuAction(submenu)">
                        <div class="mobile-links__item" appCollapseItem="mobile-links__item--open"
                            #item="appCollapseItem">
                            <div class="mobile-links__item-title ml-5">
                                <i *ngIf="submenu.iconClass !== 'fa fa-money'" class="{{ submenu.iconClass }} menu-icon"
                                    aria-hidden="true"></i>
                                <a class="mobile-links__item-link" (click)="onItemClick(submenu)"
                                    [routerLink]="submenu?.pageURL ? submenu?.pageURL : null">{{ submenu.pageCaption
                                    }}</a>
                                <button *ngIf="submenu?.subMenu?.length" class="mobile-links__item-toggle" type="button"
                                    (click)="item.toggle()">
                                    <app-icon class="mobile-links__item-arrow" name="arrow-rounded-down-12x7"
                                        size="12x7"></app-icon>
                                </button>
                            </div>                            
                            <div *ngIf="submenu?.subMenu?.length" class="mobile-links__item-sub-links" appCollapseContent>
                                <ul class="mobile-links mobile-links--level--{{ level }}" appCollapse>
                                    <li class="nav-item sub" *ngFor="let subsubmenu of submenu.subMenu"
                                        [ngClass]="{'subactive':submenu.pageURL === currentUrl}"
                                        (click)="menuAction(subsubmenu)">
                                        <div class="mobile-links__item" appCollapseItem="mobile-links__item--open"
                                            #item="appCollapseItem">
                                            <div class="mobile-links__item-title ml-5">
                                                <i *ngIf="subsubmenu.iconClass !== 'fa fa-money'"
                                                    class="{{ subsubmenu.iconClass }} menu-icon"
                                                    aria-hidden="true"></i>
                                                <a class="mobile-links__item-link" (click)="onItemClick(subsubmenu)"
                                                    [routerLink]="subsubmenu?.pageURL ? subsubmenu?.pageURL : null">{{
                                                    subsubmenu.pageCaption
                                                    }}</a>

                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div *ngIf="link.type === 'divider'" class="mobile-links__divider"></div>
    </li>
</ul>